import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useParams, useLocation } from 'react-router-dom';
import { getLeaveById, getLeaveTemplate, leaveCount, postLeave, remainingLeave, updateLeave, getWorkdaysCount } from '../../service/WfhAPI';
import Select from 'react-select';
import { directory } from '../../service/PerformanceAPI';
import { useRef } from 'react';
import { uploadBackend } from '../../utils/Upload';
import moment from 'moment';
import { getS3 } from '../../utils/Download';
import { AES } from 'crypto-js';
import './Wfh.css';

import Loader from '../../StaticComponent/Loader';
import { connect } from 'react-redux';
import { NotificationTrigger, OnlyNumber, OnlyNumberSpecialChar } from '../../utils/RegHandling';
import BreadCrumbs from '../../components/BreadCrumbs/BreadCrumbs';
import _ from 'lodash';
import { encryptStorage } from '../../constant';
import { sendMail } from '../../service/RecruiterApi';
import { getReportingEmpId } from '../../service/DirectorAPI';

function LeaveForm({ websocket }) {
    const attachment = useRef(null);
    const { leaveId } = useParams();
    const navigate = useNavigate();
    const { state } = useLocation();

    let details = { role: '', roleId: '', domain: '', username: '' };
    const [userDetails, setUserDetails] = useState(details);

    const [isAttachment, setIsAttachment] = useState(false);
    const [isAvailability, setIsAvailability] = useState(false);
    const [isDependency, setIsDependency] = useState(false);

    const [leaveUpdate, setleaveUpdate] = useState(false);
    const [leaveEdit, setleaveEdit] = useState(false);
    const [isHalf, setisHalf] = useState(false);
    const textarearef = useRef(null);

    const [leaveTypeValidation, setLeaveTypeValidation] = useState('');
    const [startDateValidation, setStartDateValidation] = useState('');
    const [endDateValidation, setEndDateValidation] = useState('');
    const [reasonValidation, setReasonValidation] = useState('');
    const [availabiltyValidation, setAvailabilityValidation] = useState('');
    const [dependentWorkValidation, setDependentWorkValidation] = useState('');
    const [responsiblePersonValidation, setResponsiblePersonValidation] = useState('');
    const [alternateNumValidation, setAlternateNumValidation] = useState('');
    const [attachmentValidation, setattachmentValidation] = useState('');
    const [leaveTemplate, setLeaveTemplate] = useState([]);
    const [showEmployee, setShowEmployee] = useState([]);
    const [selectedPeopleList, setSelectedPeopleList] = useState([]);
    const [responsiblePerson, setResponsiblePerson] = useState([]);
    const [Availability, setAvailability] = useState([]);
    const [Count, setCount] = useState({});
    const [remaining, setRemaining] = useState({});
    const [isLoading, setIsLoading] = useState(true);
    const [notifyTo, setNotifyTo] = useState();
    const [checkRadio, setcheckRadio] = useState(false);
    const [breadCrumbsData, setbreadCrumbsData] = useState([]);
    const [submit, setSubmit] = useState('Apply');
    const [formTitle, setFormTitle] = useState('Apply for Leave');
    const [applyLop, setApplyLop] = useState(false);
    const [selectedLop, setSelectedLop] = useState(false);
    const [updateEmpId, setUpdateEmpId] = useState();
    const [showHalfDayLeave, setshowHalfDayLeave] = useState(false);

    const [editBack, setEditBack] = useState(false);

    const [disabledCheck, setDisabledCheck] = useState(false);
    const [isEditMode, setIsEditMode] = useState(false);
    const [isApplyForm, setIsApplyForm] = useState(true);

    let obj = {
        1: false,
        2: false,
        3: false,
    };
    // const [checkBox, setCheckBox] = useState(obj)

    let dataObj = {
        emp_id: '',
        leave_type: '',
        approvedById: '',
        leave_status_id: '',
        start_date: '',
        alternate_number: '',
        reason: '',
        dependent_work: '',
        attachment_url: '',
        start_date: '',
        end_date: '',
        leaveId: '',
        availablities: '',
        comments: '',
    };

    let oldDataObj = {
        emp_id: '',
        leave_type: '',
        approvedById: '',
        leave_status_id: '',
        start_date: '',
        alternate_number: '',
        reason: '',
        dependent_work: '',
        attachment_url: '',
        start_date: '',
        end_date: '',
        leaveId: '',
        availablities: '',
        comments: '',
    };

    const [leaveform, setleaveform] = useState(dataObj);
    const [oldLeaveForm, setOldLeaveForm] = useState(dataObj);
    const [oldLeaveFormData, setOldLeaveFormData] = useState(oldDataObj);
    const [checkBoxValue, setCheckBoxValue] = useState(obj);
    const [flag, setFlag] = useState(false);
    const [reportsTo, setReportsTo] = useState();
    const [commentsValidation, setCommentsValidation] = useState('');
    const [lop, setLop] = useState('');
    const [logs, setLogs] = useState('');
    const [selectedFileName, setSelectedFileName] = React.useState('');
    const isProfile = window.location.href.includes('IsTeamMember');
    const [wordDays, setWordDays] = useState(0);
    const [chosedTemplate, setChoosedTemplate] = useState('');

    useEffect(() => {
        // ;
        if (state?.way == 'howDoI') {
            setbreadCrumbsData([
                { title: 'Dashboard', path: '/overview', isActive: true },
                { title: `How Do I`, path: ``, isActive: true },
                { title: 'Apply Leave', path: '', isActive: false },
            ]);
        } else if (state?.switchTab == 'Dashboard') {
            setbreadCrumbsData([
                { title: 'Dashboard', path: '/overview', isActive: true },
                { title: 'Apply Leave', path: '', isActive: false },
            ]);
        } else {
            setbreadCrumbsData([
                { title: 'Dashboard', path: '/overview', isActive: true },
                { title: `Leave`, path: `/leavewfh?tab=leave`, isActive: true },
                { title: leaveId ? 'Review Leave Request' : 'Apply Leave', path: '', isActive: false },
            ]);
        }
        // if(leaveId === null || leaveId === undefined){
        //     setIsLoading(true)
        // }
        setIsLoading(false);
        userDetails.roleId = encryptStorage.getItem('employeeId');
        userDetails.role = encryptStorage.getItem('role');
        userDetails.domain = encryptStorage.getItem('department');
        userDetails.username = encryptStorage.getItem('username');
        setUserDetails({ ...userDetails });
        getTemplate();
        bind();
        setIsApplyForm(!leaveId)

        getLeave();

        LoadDataEditView();

        // ;

        setIsLoading(false);
    }, [leaveId]);

    async function getLeave() {

        let data = {

            empId: encryptStorage.getItem('employeeId')

        }

        let res = await leaveCount(data)


        setCount(res.data.ResponseData);

        setNotifyTo(res.data.reportsTo);

    }

    useEffect(() => {
        if (isProfile) {
            setbreadCrumbsData([
                { title: 'Dashboard', path: '/overview', isActive: true },
                { title: `My Profile`, path: `/profilecontainer?EmpId=${userDetails.roleId}&IsTeamMember=true`, isActive: true },
                { title: 'Apply Leave', path: '', isActive: false },
            ]);
        }
    }, [isProfile, userDetails.roleId]);

    useEffect(() => {
        let isSame = _.isEqual(oldLeaveForm, leaveform);

        if (leaveId && isSame) setDisabledCheck(true);
        else if (!isSame) setDisabledCheck(false);
    }, [leaveform, oldLeaveForm, disabledCheck]);

    const getTemplate = async () => {
        setIsLoading(false);
        getLeaveTemplate().then((res) => {
            setLeaveTemplate(res.data.ResponseData);
            setIsLoading(true);
        });
    };

    useEffect(() => {
        setIsLoading(false);
        leaveCount({ empId: updateEmpId }).then((res) => {
            setCount(res.data.ResponseData);
        });
        setIsLoading(true);
    }, [leaveUpdate]);

    const fileUpload = async (ref) => {

        let dirName = `Leave-Form`;
        let file = attachment.current.files[0];
        let newFileName = attachment.current.files[0].name;
        let fileData = await uploadBackend(file, newFileName, dirName);
        return fileData;
    };

    const addFileName = (e) => {
        //;
        setattachmentValidation('');
        setSelectedFileName(e.target.files[0].name);
        if (e.target.files[0].size >= 250000) {
            setattachmentValidation('File size should be less than 250KB');
            attachment.current.value = '';
            return false;
        }
        const typeArr = ['pdf', 'doc', 'docx', 'jpg', 'png'];
        let type = typeArr.includes(e.target.files[0].name.split('.')[1]);
        if (type == false) {
            setattachmentValidation('The uploaded file should be in PDF or DOC format');
            attachment.current.value = '';
            return false;
        }
    };

    const getCurrentleaveCount = async (data) => {
        // ;
        let response = await getWorkdaysCount(data);
        setWordDays(response?.data?.ResponseData?.workDays);
        let count = response?.data?.ResponseData?.workDays;
        if (Count?.[chosedTemplate] == 0 || Count?.[chosedTemplate] - count < 0) {
            setApplyLop(true);
        } else setApplyLop(false);
    };
    const getHalfCurrentleaveCount = async (data) => {
        if (Count?.[chosedTemplate] == 0 || Count?.[chosedTemplate] - 0.5 < 0) {
            setApplyLop(true);
        } else setApplyLop(false);
    };

    const handleChange = (e) => {
        let selectedValue = [];
        let attend = [];
        selectedValue = e;
        e.map((data) => {
            attend.push(data.value);
        });
        setSelectedPeopleList(selectedValue);
        setResponsiblePersonValidation('');
        setleaveform({ ...leaveform, responsiblePerson: selectedPeopleList });
    };
    const markasHalfDay = (e) => {
        try {
            if (isApplyForm || isEditMode) {
                const isChecked = e.target.checked;
                setisHalf(isChecked);
                setleaveform(prev => ({ ...prev, ishalf: isChecked }));
                if (isChecked) {
                    getHalfCurrentleaveCount();
                } else {
                    let startdate = leaveform.start_date;
                    let enddate = leaveform.end_date;
                    let data = { startdate, enddate };
                    getCurrentleaveCount(data);
                }
            }
        } catch (e) {
            throw e;
        }
    };

    const OnValueChange = (e) => {
        // ;
        let start_date = leaveform.start_date;
        let end_date = leaveform.end_date;
        if (e.target.name == 'start_date' || e.target.name == 'end_date') {
            // Always uncheck the half-day checkbox when changing dates
            if (e.target.name == 'start_date') {
                start_date = e.target.value;
            } else {
                end_date = e.target.value;
            }

            // Show half-day option only if start and end dates are the same and leave type is 76 or 77
            if (start_date && end_date && start_date === end_date &&
                (leaveform.leave_type == 18 || leaveform.leave_type == 3)) {
                setshowHalfDayLeave(true);
            } else {
                setshowHalfDayLeave(false);
                // Uncheck the half-day checkbox only when dates are different
                setisHalf(false);
                setleaveform(prev => ({ ...prev, ishalf: false }));
            }
            setisHalf(false);
            if (e.target.name == 'start_date') {
                setStartDateValidation('');
            } else {
                setEndDateValidation('');
            }
        }
        else if (e.target.name == 'leave_type') {
            if (end_date !== '') {
                if (start_date && end_date && end_date == start_date) {
                    if (e.target.value == 18 || e.target.value == 3) {
                        setshowHalfDayLeave(true);
                    } else {
                        setshowHalfDayLeave(false);
                        setisHalf(false);
                        setleaveform(prev => ({ ...prev, ishalf: false }));
                    }
                }
            }
            setLeaveTypeValidation('');
        }
        if (e.target.name == 'start_date') {
            if (e.target.value !== '') {
                if (end_date == e.target.value) {
                    if (leaveform.leave_type == 18 || leaveform.leave_type == 3) {
                        setshowHalfDayLeave(true);
                    } else {
                        setshowHalfDayLeave(false);
                        setisHalf(false);
                        setleaveform(prev => ({ ...prev, ishalf: false }));
                    }
                } else {
                    setshowHalfDayLeave(false);
                    setisHalf(false);
                    setleaveform(prev => ({ ...prev, ishalf: false }));
                }
                setStartDateValidation('');
                start_date = e.target.value;
            } else {
                setshowHalfDayLeave(false);
                setisHalf(false);
                setleaveform(prev => ({ ...prev, ishalf: false }));
            }
        }
        if (e.target.name == 'end_date') {
            // ;
            if (e.target.value !== '') {
                if (e.target.value == start_date) {
                    if (leaveform.leave_type == 18 || leaveform.leave_type == 3) {
                        setshowHalfDayLeave(true);
                    } else {
                        setshowHalfDayLeave(false);
                        setisHalf(false);
                        setleaveform(prev => ({ ...prev, ishalf: false }));
                    }
                    setEndDateValidation('');
                    end_date = e.target.value;
                } else {
                    setshowHalfDayLeave(false);
                    setisHalf(false);
                    setleaveform(prev => ({ ...prev, ishalf: false }));
                }
            } else {
                setshowHalfDayLeave(false);
                setisHalf(false);
                setleaveform(prev => ({ ...prev, ishalf: false }));
            }
        }
        if (e.target.name == 'alternate_number') {
            setAlternateNumValidation('');
        }
        if (e.target.name == 'availablities') {
            setAvailability('');
        }
        if (e.target.name == 'dependent_work') {
            setDependentWorkValidation('');
        }
        if (e.target.name == 'reason') {
            setReasonValidation('');
        }
        if (e.target.name == 'comments') {
            setCommentsValidation('');
        }
        // if(e.target.name == "assigned_to_id"){}
        // setleaveform({ ...leaveform, [e.target.name]: e.target.value });
        if (e.target.name == 'start_date' || e.target.name == 'end_date') {
            setleaveform(prev => ({ ...prev, [e.target.name]: e.target.value, ishalf: false }));
        } else {
            setleaveform({ ...leaveform, [e.target.name]: e.target.value });
        }

        if (start_date && end_date) {
            start_date = moment(start_date).utc().format('YYYY-MM-DD');
            end_date = moment(end_date).utc().format('YYYY-MM-DD');

            let data = {
                start_date,
                end_date,
            };
            // if (isHalf == true) {
            //     if (start_date == end_date) {
            //         getHalfCurrentleaveCount();
            //     }
            // } else {
            //     getCurrentleaveCount(data);
            // }
            getCurrentleaveCount(data);
        }
    };

    const bind = async (value) => {
        setIsLoading(false);
        let empResult;
        empResult = await directory({});
        let samplearray = [];
        let temparray = empResult.data.ResponseData.emplist;
        for (let i = 0; i <= temparray?.length - 1; i++) {
            let objresponse = {
                value: temparray[i].emp_id,
                img: '/Images/logo-person-user-person-icon.jpg',
                label: temparray[i].emp_name,
                username: temparray[i].emp_name,
            };
            samplearray.push(objresponse);
        }
        setShowEmployee(samplearray);
        setIsLoading(true);
    };

    const LoadDataEditView = async () => {
        // ;
        setIsLoading(false);
        let validReportTo = false;


        if (leaveId) {
            setSubmit('Update & Apply');
            setFormTitle('Edit Leave Details');
            setEditBack(true);
            setIsEditMode(false);
            let responsedata = await getLeaveById({ leaveId: leaveId });
            // if (responsedata?.data?.ResponseData[0].ishalf == true) {
            //     setshowHalfDayLeave(true);
            // } else {
            //     setshowHalfDayLeave(false);
            //     setisHalf(false);
            // }
            if (responsedata?.data?.ResponseData[0].start_date === responsedata?.data?.ResponseData[0].end_date &&
                (responsedata?.data?.ResponseData[0].leave_type == 18 || responsedata?.data?.ResponseData[0].leave_type == 3)) {
                setshowHalfDayLeave(true);
                setisHalf(responsedata?.data?.ResponseData[0].ishalf);
            } else {
                setshowHalfDayLeave(false);
                setisHalf(false);
            }
            responsedata.data.ResponseData[0].ishalf = responsedata?.data?.ResponseData[0].ishalf;

            ;
            switch (encryptStorage.getItem('groupid')) {
                case '1':
                    {
                        validReportTo = true;
                        break;
                    }
                case '2':
                    {
                        if (encryptStorage.getItem('employeeId') == responsedata?.data?.ResponseData[0].emp_id) {
                            validReportTo = true;

                        }
                        else {

                            let request = {
                                login_id: encryptStorage.getItem('employeeId'),
                            };
                            let respdata = await getReportingEmpId(request);

                            for (let i = 0; i < respdata.data.ResponseData[0]?.length; i++) {
                                if (respdata.data.ResponseData[0][i]?.emp_id === responsedata?.data?.ResponseData[0]?.emp_id) {
                                    validReportTo = true;
                                }
                                //
                            }
                        }
                        break;
                    }
                case '3':
                    {
                        if (responsedata?.data?.ResponseData[0]?.emp_id == encryptStorage.getItem('employeeId'))
                            validReportTo = true;
                        break
                    }
                default:
                    {
                        navigate('*')
                        break;
                    }

            }
            if (validReportTo) {
                setleaveform(responsedata?.data?.ResponseData[0]);
                setOldLeaveForm(responsedata?.data?.ResponseData[0]);
                setOldLeaveFormData(responsedata?.data?.ResponseData[0]);
                setLogs(responsedata?.data.logs);
                setReportsTo(responsedata.data.ResponseData[0].reports_to);
                setResponsiblePerson(responsedata.data.reponsible_persons);
                setAvailability(responsedata.data.availability);

                if (leaveTemplate?.length) {
                    leaveTemplate?.map((temp) => {
                        if (temp.id == responsedata.data.ResponseData[0]?.leave_type) {
                            setIsAttachment(temp.is_attachment);
                            setIsAvailability(temp.is_availability);
                            setIsDependency(temp.is_dependency);
                        }
                    });
                }

                //;
                leaveform.attachment_url = responsedata.data.ResponseData[0].attachment_url;
                responsedata.data.availability.map((res) => {
                    let obj = checkBoxValue;
                    obj[res.availability_id] = true;
                    setCheckBoxValue(obj);
                });

                let list = [];

                if (responsedata.data?.reponsible_persons?.length) {
                    responsedata.data?.reponsible_persons?.map((res) => {
                        let obj = {
                            value: res.responsible_person_id,
                            label: res.emp_name,
                            username: res.emp_name,
                        };
                        list.push(obj);
                    });
                }

                let obj = {
                    emp_id: responsedata.data.ResponseData[0].emp_id,
                    leave_type: responsedata.data.ResponseData[0].leave_type,
                    leaveId: responsedata.data.ResponseData[0].id,
                };
                

                if (
                    responsedata.data.ResponseData[0].type.toLowerCase().includes('casual') ||
                    responsedata.data.ResponseData[0].type.toLowerCase().includes('sick')
                ) {
                    ;
                    remainingLeave(obj).then((res) => {
                        setRemaining(res.data.ResponseData);
                    });
                }

                setSelectedPeopleList(list);

                let a =
                    userDetails.roleId === responsedata.data.ResponseData[0].reports_to
                        ? setleaveEdit(false)
                        : userDetails.roleId === responsedata.data.ResponseData[0].emp_id &&
                            responsedata.data.ResponseData[0].emp_id == 'Pending'
                            ? setleaveEdit(true)
                            : leaveId === undefined
                                ? setleaveEdit(true)
                                : setleaveEdit(false);
            }
            else {
                navigate('/', { state: { hideNav: false } })
            }
        } else {
            setleaveEdit(true);
        }
        setIsLoading(true);
    };

    const tempFunc = (template) => {
        //;

        if (template?.length > 0)
            template.map((temp) => {
                if (temp.id == leaveform.leave_type) {
                    setIsAttachment(temp.is_attachment);
                    setIsAvailability(temp.is_availability);
                    setIsDependency(temp.is_dependency);
                }
            });
    };
    const formatDateForTimezone = (dateString, timezone) => {
        // Parse the input date string and add one day to compensate for the shift
        const date = new Date(dateString);
        date.setDate(date.getDate() + 1);

        // Format the date as YYYY/MM/DD in the specified timezone
        const options = { year: 'numeric', month: '2-digit', day: '2-digit', timeZone: timezone };
        const formattedDate = date.toLocaleDateString('en-US', options);

        // Rearrange the date parts to YYYY/MM/DD format
        const [month, day, year] = formattedDate.split('/');
        return `${year}/${month}/${day}`;
    };


    const applyClicked = async () => {
        //;
        setIsLoading(false);
        if (leaveUpdate) {
            let attachmentUrl = '';
            if (attachment.current.files?.length > 0) {
                let dataAttachemnt = await fileUpload(attachment);
                attachmentUrl = dataAttachemnt;
            }

            let responsiblePerson = [];
            selectedPeopleList.map((res) => {
                responsiblePerson.push(res.value);
            });

            let availablities = [];
            for (const key in checkBoxValue) {
                if (checkBoxValue[key] == true) {
                    availablities.push(key);
                }
            }
            leaveform.responsiblePerson = responsiblePerson;
            leaveform.availablities = availablities;
            leaveform.attachment_url = attachmentUrl;

            ApproveRequest('Pending');
        } else {
            let attachmentUrl = '';
            if (attachment.current.files?.length > 0) {
                let dataAttachemnt = await fileUpload(attachment);
                attachmentUrl = dataAttachemnt;
            }
            //    let attachmentLink = await fileUpload()

            let responsiblePerson = [];
            selectedPeopleList.map((res) => {
                responsiblePerson.push(res.value);
            });

            let availablities = [];
            for (const key in checkBoxValue) {
                if (checkBoxValue[key] == true) {
                    availablities.push(key);
                }
            }
            let insertData = {
                emp_id: userDetails.roleId,
                leave_type: leaveform.leave_type,
                start_date: leaveform.start_date,
                alternateContact: leaveform.alternate_number,
                reason: leaveform.reason,
                dependentWork: leaveform.dependent_work,
                attachment_url: attachmentUrl,
                end_date: leaveform.end_date,
                responsiblePerson: responsiblePerson,
                availablities: availablities,
                halfCheck: isHalf,
                // to_employee: notifyTo,
            };

            let response = await postLeave(insertData);
            let email = response.data.Email;

            if (response.data.ResponseData === 'Successfully inserted') {
                ;
                NotificationTrigger(
                    {
                        title: 'Leave',
                        message: `Leave request was raised`,
                        route: `leaveform/${response.data.leaveId}`,
                        state: { state: { switchTab: 'allLeave' } },
                        to_employee: notifyTo,
                        by: userDetails.roleId,
                    },
                    notifyTo,
                    websocket
                ).then((res) => {
                    if (isProfile) {
                        window.location.href = `/profilecontainer?EmpId=${userDetails.roleId}&IsTeamMember=true&tab=Leave`;
                    } else if (state?.switchTab == 'Dashboard') {
                        navigate(`/leavewfh?tab=leave`);
                    } else {
                        if (state?.switchTab == null) {
                            navigate(`/leavewfh`);
                        } else {
                            navigate(`/leavewfh?tab=${state?.switchTab}`);
                        }
                    }
                    sessionStorage.setItem('showToast', 'Applied Succesfully');
                    sessionStorage.setItem('ToastParagraph', 'Leave Applied Succesfully');
                    sessionStorage.setItem('ToastColour', 'green');
                    setIsLoading(true);
                });

                const timezone = userDetails.domain === 'India' ? 'Asia/Kolkata' : 'America/Chicago';
                let startdate = formatDateForTimezone(email.From, timezone);
                let enddate = formatDateForTimezone(email.To, timezone);

                let content = {
                    Subject: `${email.leaveType} Leave Request - ${email.teamMemberName}`,
                    body: `

                    <div style="width: 100%; font-family:'Open Sans'; margin-left: auto; margin-right: auto; max-width: 960px;">
                    <h3 style="font-family:'Segoe UI'; ">Hi ${email.teamMemberName},</h3> 
                    <p style="font-family:'Segoe UI'; margin-bottom: 24px;">Your <strong>${email.leaveType} Leave</strong> request has been submitted for approval to <strong>${email.ManagerName}.</strong>You will be notified on the approval status. </p>
                   <div style="box-shadow: 10px 10px 12px 4px #F4F4F4; padding:4px 16px; border: 1px solid #DEBA3C;
                   border-radius: 8px;">
                   <p style="font-family:'Segoe UI'; display: flex; margin: 0; padding: 8px 0px; border-bottom: 1px solid #e3e3e3; align-items: center;"><strong style="display: block;width: 50%; padding-right: 5%;">Request ID</strong><span style="display: block;width: 45%;"><a href="https://hive.avasoft.com/leaveform/${email.RequestID}">${email.RequestID}</a></span></p>
                    <p style="font-family:'Segoe UI'; display: flex; margin: 0; padding: 8px 0px; border-bottom: 1px solid #e3e3e3; align-items: center;"><strong style="display: block;width: 50%; padding-right: 5%;">From Date</strong><span style="display: block;width: 45%;">${startdate}</span></p>
                    <p style="font-family:'Segoe UI'; display: flex; margin: 0; padding: 8px 0px; border-bottom: 1px solid #e3e3e3; align-items: center;"><strong style="display: block;width: 50%; padding-right: 5%;">To Date</strong><span style="display: block;width: 45%;">${enddate}</span></p>
                    <p style="font-family:'Segoe UI'; display: flex; margin: 0; padding: 8px 0px; border-bottom: 1px solid #e3e3e3; align-items: center;"><strong style="display: block;width: 50%; padding-right: 5%;">No. of Working Days?</strong><span style="display: block;width: 45%;">${email.workDays}</span></p>
                    <p style="font-family:'Segoe UI'; display: flex; margin: 0; padding: 8px 0px; border-bottom: 1px solid #e3e3e3; align-items: center;"><strong style="display: block;width: 50%; padding-right: 5%;">No. of Days (Weekend \Holidays)?</strong><span style="display: block;width: 45%;">${email.weekDays}</span></p>
                    <p style="font-family:'Segoe UI'; display: flex; margin: 0; padding: 8px 0px; border-bottom: 1px solid #e3e3e3; align-items: center;"><strong style="display: block;width: 50%; padding-right: 5%;">Dependency Work and Responsible person</strong><span style="display: block;width: 45%;">${email.dependentWork}-${email.responsiblePerson}</span></p>
                    <p style="font-family:'Segoe UI'; display: flex; margin: 0; padding: 8px 0px; border-bottom: 1px solid #e3e3e3; align-items: center;"><strong style="display: block;width: 50%; padding-right: 5%;">Reason for Leave</strong><span style="display: block;width: 45%;">${email.reason}</span></p>
                    <p style="font-family:'Segoe UI'; display: flex; margin: 0; padding: 8px 0px; border-bottom: 1px solid #e3e3e3; align-items: center;"><strong style="display: block;width: 50%; padding-right: 5%;">Alternate Contact Number</strong><span style="display: block;width: 45%;">${email.alternateContact}</span></p>
                    <p style="font-family:'Segoe UI'; display: flex; margin: 0; padding: 8px 0px;  align-items: center;"><strong style="display: block;width: 50%; padding-right: 5%;">Availability in case of emergency</strong><span style="display: block;width: 45%;">${email.availability}</span></p>
                 
                   </div>
                  
                   
                  </div>


                   `,
                    to: [email.teamMemberEmail],
                    cc: [email.ManagerEmail],

                    from: 'hrcommunications@avasoft.com',
                    // from: 'alexis@avasoft.com',
                };
                sendMail(content);
            }
            else if (response.data.ResponseData === 'Date already exist') {
                if (state?.switchTab == null) {
                    navigate(`/leavewfh`);
                } else {
                    navigate(`/leavewfh?tab=${state?.switchTab}`);
                }
                sessionStorage.setItem('showToast', 'Request already exists');
                sessionStorage.setItem('ToastColour', 'Cross');
                sessionStorage.setItem('ToastParagraph', 'A leave request has already been raised for the selected date(s)');
            }
            else {
                if (state?.switchTab == null) {
                    navigate(`/leavewfh`);
                } else {
                    navigate(`/leavewfh?tab=${state?.switchTab}`);
                }
                sessionStorage.setItem('showToast', 'Something went wrong');
                sessionStorage.setItem('ToastColour', 'Cross');
                sessionStorage.setItem('ToastParagraph', response.data.ErrorMessage || 'Unable to submit your leave request. Please try again.');
            }
        }
    };

    const RejectRequest = async (id) => {
        if (leaveform.comments === '' || leaveform.comments === null) {
            setCommentsValidation('Comments for Rejection is required');
            return false;
        }
        if (leaveform.comments && OnlyNumberSpecialChar(leaveform.comments)) {
            setCommentsValidation('Enter a valid comments');
            return false;
        }
        setIsLoading(false);
        let obj = {
            status: id,
            approved_by: userDetails.roleId,
            leaveId: leaveId,
            comments: leaveform.comments,
            start_date: leaveform.start_date,
            end_date: leaveform.end_date,
            ishalf: isHalf,
        };
        let updateResult = await updateLeave({ ...obj, status: id });
        let email = updateResult?.data?.Email || {};
        let availability = (email.availability || []).map((item) => item.availability);
        let responsible = (email.responsiblePerson || []).map((item) => item.emp_name);
        let count = await leaveCount({ empId: email.requestRaiseEmp_Id });

        if (updateResult.data.ResponseData === 'Successfully updated') {
            ;
            NotificationTrigger(
                {
                    title: 'Leave',
                    message: 'Your leave request was rejected',
                    /* route: 'leaveform', */ route: `leaveform/${leaveId}`,
                    state: { state: { switchTab: 'leave' } },
                    to_employee: [leaveform.emp_id],
                    by: userDetails.roleId,
                },
                [leaveform.emp_id],
                websocket
            ).then((res) => {
                if (state?.switchTab == null) {
                    navigate(`/leavewfh`);
                } else {
                    navigate(`/leavewfh?tab=${state?.switchTab}`);
                }
                //navigate(`/leavewfh?tab=${state.switchTab}`);
                sessionStorage.setItem('showToast', 'Rejected Succesfully');
                sessionStorage.setItem('ToastColour', 'Cross');
                sessionStorage.setItem('ToastParagraph', 'Leave Rejected Succesfully');
                setIsLoading(true);
            });
            const timezone = userDetails.domain === 'India' ? 'Asia/Kolkata' : 'America/Chicago';
            let startdate = formatDateForTimezone(email.From, timezone);
            let enddate = formatDateForTimezone(email.To, timezone);

            let content = {
                Subject: `${email.leaveType} Leave Request has been Rejected- ${email.teamMemberName}`,
                body: `

                <div style="width: 100%; font-family:'Open Sans'; margin-left: auto; margin-right: auto; max-width: 960px;">
                <h3 style="font-family:'Segoe UI'; ">Hi ${email.teamMemberName},</h3> 
                <p style="font-family:'Segoe UI'; margin-bottom: 24px;">Your <strong>${email.leaveType
                    } Leave</strong> request was <strong>Rejected</strong> by <strong>${email.ManagerName}</strong> </p>
               <div style="box-shadow: 10px 10px 12px 4px #F4F4F4; padding:4px 16px; border: 1px solid #DEBA3C;
               border-radius: 8px;">
               <p style="font-family:'Segoe UI'; display: flex; margin: 0; padding: 8px 0px; border-bottom: 1px solid #e3e3e3; align-items: center;"><strong style="display: block;width: 50%; padding-right: 5%;">Request ID</strong><span style="display: block;width: 45%;"><a href="https://hive.avasoft.com/leaveform/${email.RequestID
                    }">${email.RequestID}</a></span></p>
                <p style="font-family:'Segoe UI'; display: flex; margin: 0; padding: 8px 0px; border-bottom: 1px solid #e3e3e3; align-items: center;"><strong style="display: block;width: 50%; padding-right: 5%;">From Date</strong><span style="display: block;width: 45%;">${startdate
                    }</span></p>
                <p style="font-family:'Segoe UI'; display: flex; margin: 0; padding: 8px 0px; border-bottom: 1px solid #e3e3e3; align-items: center;"><strong style="display: block;width: 50%; padding-right: 5%;">To Date</strong><span style="display: block;width: 45%;">${enddate
                    }</span></p>
                <p style="font-family:'Segoe UI'; display: flex; margin: 0; padding: 8px 0px; border-bottom: 1px solid #e3e3e3; align-items: center;"><strong style="display: block;width: 50%; padding-right: 5%;">No. of Working Days?</strong><span style="display: block;width: 45%;">${email.workDays
                    }</span></p>
                <p style="font-family:'Segoe UI'; display: flex; margin: 0; padding: 8px 0px; border-bottom: 1px solid #e3e3e3; align-items: center;"><strong style="display: block;width: 50%; padding-right: 5%;">No. of Days (Weekend \Holidays)?</strong><span style="display: block;width: 45%;">${email.weekDays
                    }</span></p>
                <p style="font-family:'Segoe UI'; display: flex; margin: 0; padding: 8px 0px; border-bottom: 1px solid #e3e3e3; align-items: center;"><strong style="display: block;width: 50%; padding-right: 5%;">Dependency Work and Responsible person</strong><span style="display: block;width: 45%;">${email.dependentWork
                    }-${responsible}</span></p>
                <p style="font-family:'Segoe UI'; display: flex; margin: 0; padding: 8px 0px; border-bottom: 1px solid #e3e3e3; align-items: center;"><strong style="display: block;width: 50%; padding-right: 5%;">Reason for Leave</strong><span style="display: block;width: 45%;">${email.reason
                    }</span></p>
                <p style="font-family:'Segoe UI'; display: flex; margin: 0; padding: 8px 0px; border-bottom: 1px solid #e3e3e3; align-items: center;"><strong style="display: block;width: 50%; padding-right: 5%;">Alternate Contact Number</strong><span style="display: block;width: 45%;">${email.alternateContact
                    }</span></p>
                <p style="font-family:'Segoe UI'; display: flex; margin: 0; padding: 8px 0px; border-bottom: 1px solid #e3e3e3; align-items: center;"><strong style="display: block;width: 50%; padding-right: 5%;">Availability in case of emergency</strong><span style="display: block;width: 45%;">${availability}</span></p>
                <p style="font-family:'Segoe UI'; display: flex; margin: 0; padding: 8px 0px; border-bottom: 1px solid #e3e3e3 !important; align-items: center"><strong style="display: block;width: 50%; padding-right: 5%;">Comments</strong><span style="display: block;width: 45%;">${email.comments == null ? '-' : email.comments
                    }</span ></p>
                <p style="font-family:'Segoe UI'; display: flex; margin: 0; padding: 8px 0px; border-bottom: 1px solid #e3e3e3 !important; align-items: center"><strong style="display: block;width: 50%; padding-right: 5%;">Available Casual leave</strong><span style="display: block;width:45%;">${count?.data.ResponseData.casual
                    }</span></p>
                <p style="font-family:'Segoe UI'; display: flex; margin: 0; padding: 8px 0px; align-items: center;"><strong style="display: block;width: 50%; padding-right: 5%;">Available Sick Leave</strong><span>${count?.data.ResponseData.sick
                    }</span></p>
             
               </div>
              
               
              </div>


               `,
                to: [email.teamMemberEmail],
                cc: [email.ManagerEmail],
                from: 'hrcommunications@avasoft.com',
                // from: 'alexis@avasoft.com',

            };
            sendMail(content);
        }
    };

    const ApproveRequest = async (value) => {
        ;
        // if (value !== "Revoked" && userDetails.role != "Team Member") {
        //     // if (leaveform.comments === '' || leaveform.comments === null) {
        //     //     setCommentsValidation("Comments for Approval is required")
        //     //     return false;
        //     // }
        // }

        setIsLoading(false);

        let attachmentUrl = '';

        if (attachment.current?.files?.length > 0) {
            let dataAttachemnt = await fileUpload(attachment);
            attachmentUrl = dataAttachemnt;
        }

        leaveform.attachment_url = attachmentUrl;

        let obj =
            value !== 'Pending'
                ? {
                    status: `${value}`,
                    approved_by: userDetails.roleId,
                    leaveId: leaveId,
                    comments: leaveform.comments,
                    lop: lop,
                    start_date: leaveform.start_date,
                    end_date: leaveform.end_date,
                    ishalf: isHalf,
                    // empId: userDetails.roleId
                }
                : {
                    status: `${value}`,
                    leaveId: leaveId,
                    reason: leaveform.reason,
                    start_date: leaveform.start_date,
                    end_date: leaveform.end_date,
                    ishalf: isHalf,
                    // leave_type: 3
                    // empId: userDetails.roleId
                };
        let responsiblePerson = [];
        selectedPeopleList.map((res) => {
            responsiblePerson.push(res.value);
        });

        let availablities = [];
        for (const key in checkBoxValue) {
            if (checkBoxValue[key] == true) {
                availablities.push(key);
            }
        }
        leaveform.responsiblePerson = responsiblePerson;
        leaveform.availablities = availablities;

        // let NewValue = Object.keys(leaveform);
        // let OldValue = Object.keys(oldLeaveFormData);
        // let count = 0;
        // for (let i = 0; i <= NewValue.length; i++) {
        //     if (leaveform[NewValue[i]] != oldLeaveFormData[OldValue[i]]) {
        //         count++;
        //     }
        // }

        let isSame = _.isEqual(leaveform, oldLeaveFormData);

        if (!isSame || value == 'Approved' || value == 'Revoked' || value == 'Updated and Approved') {
            let newobj = { ...obj, ...leaveform };

            if (value !== 'Pending') {
                NotificationTrigger(
                    {
                        title: 'Leave',
                        message: `Your leave request was ${value}`,
                        route: `leaveform/${leaveId}`,
                        state: { state: { switchTab: 'leave' } },
                        to_employee: [leaveform.emp_id],
                        by: userDetails.roleId,
                    },
                    [leaveform.emp_id],
                    websocket
                ).then((res) => {
                    if (state?.switchTab == null) {
                        navigate(`/leavewfh`);
                    } else {
                        navigate(`/leavewfh?tab=${state?.switchTab}`);
                    }
                    //navigate(`/leavewfh?tab=${state.switchTab}`);
                });
            } else {
                NotificationTrigger(
                    {
                        title: 'Leave',
                        message: `The leave request has been updated`,
                        route: `leaveform/${leaveId}`,
                        state: { state: { switchTab: 'allLeave' } },
                        to_employee: notifyTo,
                        by: userDetails.roleId,
                    },
                    notifyTo,
                    websocket
                ).then((res) => {
                    if (state?.switchTab == null) {
                        navigate(`/leavewfh`);
                    } else {
                        navigate(`/leavewfh?tab=${state?.switchTab}`);
                    }
                    //navigate(`/leavewfh?tab=${state.switchTab}`);
                });
            }
            let updateResult = await updateLeave({ ...newobj, status: value });
            let email = updateResult.data.Email;
            let availability = [];
            ;
            for (let i = 0; i < email.availability?.length; i++) {
                availability.push(email.availability[i].availability);
            }
            let responsible = [];
            for (let i = 0; i < email.responsiblePerson?.length; i++) {
                responsible.push(email.responsiblePerson[i].emp_name);
            }
            let count = await leaveCount({ empId: email.requestRaiseEmp_Id });

            let ptag, subject;
            if (value !== 'Pending') {
                subject = `${email.leaveType} Leave Request has been ${value}- ${email.teamMemberName}`;
                ptag = ` <p style="font-family:'Segoe UI'; margin-bottom: 24px;">Your <strong>${email.leaveType} Leave</strong> request was <strong>${value}</strong> by <strong>${email.ManagerName}</strong> </p>`;
            } else {
                subject = `${email.leaveType} Leave Request - ${email.teamMemberName}`;
                ptag = `<p style="font-family:'Segoe UI'; margin-bottom: 24px;">Your <strong>${email.leaveType} Leave</strong> request has been updated and submitted for <strong>approval</strong> to <strong>${email.ManagerName}</strong>.
                You will be notified on the approval status.</p>`;
            }

            if (updateResult.data.ResponseData === 'Successfully updated') {
                setIsLoading(true);
                if (state?.switchTab == null) {
                    navigate(`/leavewfh`);
                } else {
                    navigate(`/leavewfh?tab=${state?.switchTab}`);
                }
                // navigate(`/leavewfh?tab=${state.switchTab}`);
                const timezone = userDetails.domain === 'India' ? 'Asia/Kolkata' : 'America/Chicago';
                let startdate = formatDateForTimezone(email.From, timezone);
                let enddate = formatDateForTimezone(email.To, timezone);

                let content = {
                    Subject: subject,
                    body: `
    
                    <div style="width: 100%; font-family:'Open Sans'; margin-left: auto; margin-right: auto; max-width: 960px;">
                    <h3 style="font-family:'Segoe UI'; ">Hi ${email.teamMemberName},</h3> 
                   ${ptag}
                   <div style="box-shadow: 10px 10px 12px 4px #F4F4F4; padding:4px 16px; border: 1px solid #DEBA3C;
                   border-radius: 8px;">
                   <p style="font-family:'Segoe UI'; display: flex; margin: 0; padding: 8px 0px; border-bottom: 1px solid #e3e3e3 !important; align-items: center;"><strong style="display: block;width: 50%; padding-right: 5%;">Request ID</strong><span style="display: block;width: 45%;"><a href="https://hive.avasoft.com/leaveform/${email.RequestID
                        }">${email.RequestID}</a></span></p>
                    <p style="font-family:'Segoe UI'; display: flex; margin: 0; padding: 8px 0px; border-bottom: 1px solid #e3e3e3 !important; align-items: center;"><strong style="display: block;width: 50%; padding-right: 5%;">From Date</strong><span style="display: block;width: 45%;">${startdate
                        }</span></p>
                    <p style="font-family:'Segoe UI'; display: flex; margin: 0; padding: 8px 0px; border-bottom: 1px solid #e3e3e3 !important; align-items: center;"><strong style="display: block;width: 50%; padding-right: 5%;">To Date</strong><span style="display: block;width: 45%;">${startdate
                        }</span></p>
                    <p style="font-family:'Segoe UI'; display: flex; margin: 0; padding: 8px 0px; border-bottom: 1px solid #e3e3e3 !important; align-items: center;"><strong style="display: block;width: 50%; padding-right: 5%;">No. of Working Days?</strong><span style="display: block;width: 45%;">${email.workDays
                        }</span></p>
                    <p style="font-family:'Segoe UI'; display: flex; margin: 0; padding: 8px 0px; border-bottom: 1px solid #e3e3e3 !important; align-items: center;"><strong style="display: block;width: 50%; padding-right: 5%;">No. of Days (Weekend \Holidays)?</strong><span style="display: block;width: 45%;">${email.weekDays
                        }</span></p>
                    <p style="font-family:'Segoe UI'; display: flex; margin: 0; padding: 8px 0px; border-bottom: 1px solid #e3e3e3 !important; align-items: center;"><strong style="display: block;width: 50%; padding-right: 5%;">Dependency Work and Responsible person</strong><span style="display: block;width: 45%;">${email.dependentWork
                        }-${responsible}</span></p>
                    <p style="font-family:'Segoe UI'; display: flex; margin: 0; padding: 8px 0px; border-bottom: 1px solid #e3e3e3 !important; align-items: center;"><strong style="display: block;width: 50%; padding-right: 5%;">Reason for Leave</strong><span style="display: block;width: 45%;">${email.reason
                        }</span></p>
                    <p style="font-family:'Segoe UI'; display: flex; margin: 0; padding: 8px 0px; border-bottom: 1px solid #e3e3e3 !important; align-items: center;"><strong style="display: block;width: 50%; padding-right: 5%;">Alternate Contact Number</strong><span style="display: block;width: 45%;">${email.alternateContact
                        }</span></p>
                    <p style="font-family:'Segoe UI'; display: flex; margin: 0; padding: 8px 0px; border-bottom: 1px solid #e3e3e3 !important; align-items: center;"><strong style="display: block;width: 50%; padding-right: 5%;">Availability in case of emergency</strong><span style="display: block;width: 45%;">${availability}</span></p>
                    <p style="font-family:'Segoe UI'; display: flex; margin: 0; padding: 8px 0px; border-bottom: 1px solid #e3e3e3 !important; align-items: center"><strong style="display: block;width: 50%; padding-right: 5%;">Comments</strong><span style="display: block;width: 45%;">${email.comments == null ? '-' : email.comments
                        }</span ></p>
                    <p style="font-family:'Segoe UI'; display: flex; margin: 0; padding: 8px 0px; border-bottom: 1px solid #e3e3e3 !important; align-items: center"><strong style="display: block;width: 50%; padding-right: 5%;">Available Casual leave</strong><span style="display: block;width:45%;">${count?.data.ResponseData.casual
                        }</span></p>
                    <p style="font-family:'Segoe UI'; display: flex; margin: 0; padding: 8px 0px; align-items: center;"><strong style="display: block;width: 50%; padding-right: 5%;">Available Sick Leave</strong><span>${count?.data.ResponseData.sick
                        }</span></p>
                 
                   </div>
                  
                   
                  </div>
    
    
                   `,
                    to: [email.teamMemberEmail],
                    cc: [email.ManagerEmail],
                    // to: ['Nivetha.mu@avasoft.com'],
                    // //cc: [email.ManagerEmail],
                    from: 'hrcommunications@avasoft.com',
                    // from: 'alexis@avasoft.com',

                };
                sendMail(content);

                if (value == 'Pending') {
                    sessionStorage.setItem('showToast', 'Updated Succesfully');
                    sessionStorage.setItem('ToastColour', 'green');
                    sessionStorage.setItem('ToastParagraph', 'Leave Updated Succesfully');
                } else {
                    sessionStorage.setItem('showToast', value + ' Succesfully');
                    sessionStorage.setItem('ToastColour', 'green');
                    sessionStorage.setItem('ToastParagraph', 'Leave ' + value + ' Succesfully');
                }
            }
        } else {
            setIsLoading(true);
        }
    };

    const checkboxClicked = async (value) => {
        let obj = checkBoxValue;
        if (value == 3) {
            obj[3] = !obj[3];
            obj[2] = false;
            obj[1] = false;
        } else obj[value] = !obj[value];
        setCheckBoxValue(obj);
        setFlag(!flag);
        setAvailabilityValidation('');

        const availablities = [];
        for (const key in obj) {
            if (obj[key] == true) {
                availablities.push(key);
            }
        }

        setleaveform({ ...leaveform, availablities: obj });
    };

    const OnCheckValue = (res) => {
        setChoosedTemplate(res.type.toLowerCase().includes('casual') ? 'casual' : res.type.toLowerCase().includes('sick') ? 'sick' : '');

        // if ((res.type.toLowerCase().includes("casual") && Count?.casual == 0) || (res.type.toLowerCase().includes("sick") && Count?.sick == 0)) { setApplyLop(true) }
        // else setApplyLop(false)

        setIsAttachment(res.is_attachment);
        setIsAvailability(res.is_availability);
        setIsDependency(res.is_dependency);
    };

    const wfhValidation = (value = 'Apply') => {
        let result = true;
        
        if (leaveform.leave_type == '') {
            setLeaveTypeValidation('Leave type is required');
        }
        if (leaveform.start_date == '') {
            setStartDateValidation('Start date is required');
        }
        if (leaveform.end_date == '') {
            setEndDateValidation('End date is required');
        }

        if (leaveform.end_date != '' && leaveform.start_date != '') {
            if (leaveform.end_date < leaveform.start_date) {
                setEndDateValidation('Please enter valid end date');
            }
        }
        if (leaveform.reason.trim() == '') {
            //;
            setReasonValidation('Reason for leave is required ');
        }
        if (leaveform.reason.trim() != '') {
            let checkregex = OnlyNumberSpecialChar(leaveform.reason.trim());
            if (checkregex) {
                result = false;
                setReasonValidation('Enter valid reason');
            }
        }
        if (leaveform.alternate_number.trim() == '') {
            setAlternateNumValidation('Alternate Number is required');
        }
        if (leaveform.alternate_number.trim()) {
            let checkregex = OnlyNumber(leaveform.alternate_number.trim());
            if (checkregex) {
                result = false;
                setAlternateNumValidation('Enter valid Alternate Number');
            } else if (leaveform.alternate_number?.length < 10) {
                result = false;
                setAlternateNumValidation('Please Enter Valid Alternate Number');
            }
        }

        if (isDependency && selectedPeopleList?.length == 0) {
            setResponsiblePersonValidation('Responsible person  is required');
        }

        if (leaveform.dependent_work.trim() == '') {
            setDependentWorkValidation('Dependent Work is required');
        }
        if (leaveform.dependent_work.trim()) {
            let checkregex = OnlyNumberSpecialChar(leaveform.dependent_work.trim());

            if (checkregex) {
                result = false;
                setDependentWorkValidation('Enter valid Dependent Work');
            }
        }

        // if (isAttachment && selectedFileName == '' && leaveId == '') {
        //     result = false;
        //     setattachmentValidation('Attachment  is required');
        // }
        // if (isAttachment && selectedFileName == '' && leaveform.attachment_url == '' && leaveId != '') {
        //     result = false;
        //     setattachmentValidation('Attachment  is required');
        // }

        const availValid = Object.values(checkBoxValue).filter((el) => el == true);

        if (availValid?.length == 0) {
            setAvailabilityValidation('Availability is Required');
        }

        if (leaveform.comments && OnlyNumberSpecialChar(leaveform.comments)) {
            setCommentsValidation('Enter a valid comments');
            return false;
        }

        if (
            leaveform.start_date == '' ||
            leaveform.end_date == '' ||
            leaveform.reason == '' ||
            leaveform.alternate_number == '' ||
            leaveform.leave_type <= 0 ||
            leaveform.end_date < leaveform.start_date ||
            availValid?.length == 0 ||
            (isDependency == true ? selectedPeopleList == '' : null) ||
            (isDependency == true ? leaveform.dependent_work == '' : null)
        ) {
            result = false;
            return result;
        } else if (!result) {
            return result;
        }


        if (attachmentValidation == '' && alternateNumValidation == '' && value == 'Apply') {
        
            applyClicked();
        }
        if (attachmentValidation == '' && alternateNumValidation == '' && value == 'Approved') {
          
            ApproveRequest('Approved');
        }
        if (attachmentValidation == '' && alternateNumValidation == '' && value == 'Updated and Approved') {
            ApproveRequest('Updated and Approved');
        }
    };

    const bindAttachmentName = () => {
        try {
            let attachmentName = leaveform.attachment_url.substring(59);
            // let secureURL = getS3(leaveform?.attachment_url)
            return leaveform.attachment_url != '' ? (
                <>
                    <label className="form-label font-14 bold-text leave-label-color d-flex">Attachments</label>
                    <a
                        target="_blank"
                        className="attachment-color text-decoration-none regular-text font-14 pe-2"
                        id="attachment"
                        style={{cursor:"pointer"}} onClick={async () => {

                            window.open(await getS3(leaveform?.attachment_url), "_blank");


                        }} 
                    >
                        <img src="/Images/pin.svg" alt="Attachment Icon" className="me-2" />
                        {attachmentName}
                    </a>
                </>
            ) : (
                <>
                    <label className="form-label font-14 bold-text leave-label-color d-flex">Attachments</label>
                    <span className="leave-formtext-color regular-text font-14"> No attachments</span>
                </>
            );
        }
        catch (error) {
            console.log(error.message)
        }
    };

    const removeAttachment = () => {
        //;
        setSelectedFileName('');
        setattachmentValidation('');
        attachment.current.value = '';
        setleaveform({ ...leaveform, attachment_url: '' });
    };

    return (
        <>
            <Loader isLoading={isLoading} />
            <div className="container-fluid mt-5">
                <div className="mt-5"></div>
                <div className="row justify-content-center ">
                    <div className="col-md-9 ">
                        <div className="row">
                            <div className="col-md-9 pt-3 leave-rounded-7 bg-white px-4">
                                <BreadCrumbs data={breadCrumbsData} />
                                {leaveEdit ? (
                                    <>
                                        <div className="custom-leave-panel">
                                            <span className="backarrow">
                                                <a
                                                    onClick={() => {
                                                        if (state?.switchTab == 'Dashboard') window.location.href = `overview`;
                                                        // else if (editBack) setleaveEdit(!leaveEdit)
                                                        else if (editBack) window.location.reload(false);
                                                        else if (!isProfile) {
                                                            if (state?.switchTab == null) {
                                                                navigate(`/leavewfh`);
                                                            } else {
                                                                navigate(`/leavewfh?tab=${state?.switchTab}`);
                                                            }
                                                        } else
                                                            window.location.href = `/profilecontainer?EmpId=${userDetails.roleId}&IsTeamMember=true&tab=Leave`;
                                                    }}
                                                    title="Back"
                                                >
                                                    <img src="/Images/back-arrow.svg" className="me-3" alt="back-arrow" />
                                                </a>
                                            </span>
                                            {leaveEdit ? (
                                                <p className="font-15 mb-3 leave-header-color bold-text mb-5">{formTitle}</p>
                                            ) : (
                                                <p className="font-15 mb-3 leave-header-color bold-text mb-5">Edit Leave Details</p>
                                            )}
                                            <p className="form-label hive-form-label">Type of Leave</p>
                                            <div className="row">
                                                {leaveTemplate?.map((res, i) => {
                                                    if (!(res.type.toLowerCase() == 'lop') && !(res.type.toLowerCase() == 'half day')) {
                                                        return (
                                                            <div className="col-md-6 mb-3 leave-type-box">
                                                                <div
                                                                    className={
                                                                        res.id == leaveform.leave_type
                                                                            ? `border leave-border card h-100 leave-type-selected`
                                                                            : `border leave-border card h-100`
                                                                    }
                                                                >
                                                                    <div className='card-body p-0'>
                                                                        <label className="d-flex form-check align-items-center" htmlFor={i}>
                                                                            <div className="d-flex align-items-center">
                                                                                {leaveform.leave_type == res.id ? (
                                                                                    <input
                                                                                        checked
                                                                                        onClick={(e) => {
                                                                                            OnValueChange(e);
                                                                                            OnCheckValue(res);
                                                                                        }}
                                                                                        value={res.id}
                                                                                        className="form-check-input custom-radio-btn me-3"
                                                                                        type="radio"
                                                                                        name="leave_type"
                                                                                        id={i}
                                                                                    />
                                                                                ) : (
                                                                                    <input
                                                                                        onClick={(e) => {
                                                                                            setcheckRadio(!checkRadio);
                                                                                            OnValueChange(e);
                                                                                            OnCheckValue(res);
                                                                                        }}
                                                                                        value={res.id}
                                                                                        className="form-check-input custom-radio-btn me-3"
                                                                                        type="radio"
                                                                                        name="leave_type"
                                                                                        id={i}
                                                                                    />
                                                                                )}
                                                                                {/* <input  onClick={(e) => { OnValueChange(e) }} value={res.id} className="form-check-input custom-radio-btn me-3" type="radio" name="leave_type" id={i} /> */}
                                                                            </div>
                                                                            <span className="form-check-label font-14 regular-text leave-header-color">
                                                                                {res.type}
                                                                                <p className="font-13 regular-text leave-formtext-color mb-0 mt-2">
                                                                                    {res.description}
                                                                                </p>
                                                                            </span>
                                                                        </label>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        );
                                                    }
                                                })}
                                                <span style={{ color: 'red' }}>{leaveTypeValidation}</span>
                                            </div>
                                            <h1 className="form-label hive-form-label mt-5">Date Range</h1>
                                            <div className="row mb-5">
                                                <div className="col-md-3">
                                                    <label
                                                        className="form-label hive-form-label leave-date-label-color"
                                                        htmlFor="start-date"
                                                    >
                                                        Start Date <span className="required">*</span>
                                                    </label>
                                                    <input
                                                        onChange={(e) => {
                                                            OnValueChange(e);
                                                        }}
                                                        value={leaveform.start_date}
                                                        // value={leaveform.start_date}
                                                        max={leaveform.end_date}
                                                        name="start_date"
                                                        type="date"
                                                        className="form-control hive-form-control"
                                                        id="start-date"
                                                        placeholder="Select the start date "
                                                    // disabled={leaveform.ishalf}
                                                    />
                                                    <span style={{ color: 'red' }}>{startDateValidation}</span>
                                                </div>
                                                <div className="col-md-1 align-self-end d-flex justify-content-center">
                                                    <img src="/Images/right-arrow.svg" alt="right-arrow" className="mb-3" />
                                                </div>
                                                <div className="col-md-3">
                                                    <label className="form-label hive-form-label leave-date-label-color" htmlFor="end-date">
                                                        End Date <span className="required">*</span>
                                                    </label>
                                                    <input
                                                        onChange={(e) => {
                                                            OnValueChange(e);
                                                        }}
                                                        min={leaveform.start_date}
                                                        value={leaveform.end_date}
                                                        // value={leaveform.end_date}
                                                        name="end_date"
                                                        type="date"
                                                        className="form-control hive-form-control"
                                                        id="end-date"
                                                        placeholder="Select the end date "
                                                    // disabled={leaveform.ishalf}
                                                    />
                                                    <span style={{ color: 'red' }}>{endDateValidation}</span>
                                                </div>
                                                {showHalfDayLeave ? (
                                                    <div className="col-md-3" style={{ marginTop: '2rem' }}>
                                                        <input
                                                            onChange={(e) => {
                                                                markasHalfDay(e);
                                                            }}
                                                            className="form-check-input leave-checkbox me-2"
                                                            type="checkbox"
                                                            defaultValue
                                                            id="HL"
                                                            // checked={leaveform.ishalf}
                                                            checked={isHalf}
                                                            disabled={!isApplyForm && !isEditMode}
                                                        />
                                                        <label
                                                            className="form-check-label font-14 regular-text leave-date-label-color"
                                                            htmlFor="HL"
                                                        >
                                                            {/* {updateEmpId == userDetails.roleId ? "This falls under LOP" : "Approve this as LOP2"} */}
                                                            Half Day Leave
                                                        </label>
                                                    </div>
                                                ) : null}
                                            </div>

                                            <div className="row mb-5">
                                                <div className="col-md-6">
                                                    <label htmlFor="alternate#" className="form-label hive-form-label">
                                                        Alternate contact # <span className="required">*</span>
                                                    </label>
                                                    <input
                                                        name="alternate_number"
                                                        onChange={(e) => {
                                                            OnValueChange(e);
                                                        }}
                                                        minLength={10}
                                                        maxLength={10}
                                                        value={leaveform.alternate_number}
                                                        type="text"
                                                        id="alternate#"
                                                        className="form-control hive-form-control"
                                                        placeholder="Enter the  mobile number "
                                                    />
                                                    <span style={{ color: 'red' }}>{alternateNumValidation}</span>
                                                </div>
                                                <div className="col-md-6 " hidden={isAvailability || Availability != [] ? false : true}>
                                                    <label className="form-label hive-form-label">
                                                        Availability <span className="required">*</span>
                                                    </label>
                                                    <div className="mt-2">
                                                        <input
                                                            onClick={(e) => {
                                                                checkboxClicked(1);
                                                            }}
                                                            value={1}
                                                            checked={checkBoxValue[1] ? true : false}
                                                            disabled={checkBoxValue[3] ? true : false}
                                                            className="form-check-input leave-checkbox me-2"
                                                            type="checkbox"
                                                            defaultValue
                                                            id="call"
                                                        />
                                                        <label
                                                            className="form-check-label font-14 regular-text leave-date-label-color  me-4"
                                                            htmlFor="call"
                                                        >
                                                            Call
                                                        </label>
                                                        <input
                                                            onClick={(e) => {
                                                                checkboxClicked(2);
                                                            }}
                                                            value={2}
                                                            checked={checkBoxValue[2] ? true : false}
                                                            disabled={checkBoxValue[3] ? true : false}
                                                            className="form-check-input leave-checkbox me-2"
                                                            type="checkbox"
                                                            defaultValue
                                                            id="mail"
                                                        />
                                                        <label
                                                            className="form-check-label font-14 regular-text leave-date-label-color  me-4"
                                                            htmlFor="mail"
                                                        >
                                                            Mail
                                                        </label>
                                                        <input
                                                            onClick={(e) => {
                                                                checkboxClicked(3);
                                                            }}
                                                            value={3}
                                                            checked={checkBoxValue[3] ? true : false}
                                                            className="form-check-input leave-checkbox me-2"
                                                            type="checkbox"
                                                            defaultValue
                                                            id="dnd"
                                                        />
                                                        <label
                                                            className="form-check-label font-14 regular-text leave-date-label-color  "
                                                            htmlFor="dnd"
                                                        >
                                                            Do Not Disturb
                                                        </label>
                                                    </div>
                                                    <span style={{ color: 'red' }}>{availabiltyValidation}</span>
                                                </div>
                                            </div>
                                            <div>
                                                <label className="form-label hive-form-label" htmlFor="leave-reason">
                                                    Reason for Leave <span className="required">*</span>
                                                </label>
                                                <textarea
                                                    ref={textarearef}
                                                    onBlur={() => {
                                                        textarearef.current.scrollTop = 0;
                                                    }}
                                                    onChange={(e) => {
                                                        OnValueChange(e);
                                                    }}
                                                    value={leaveform.reason}
                                                    name="reason"
                                                    className="form-control hive-form-control leaveform-commentbox"
                                                    placeholder="Enter the reason "
                                                    id="leave-reason"
                                                    defaultValue={''}
                                                    maxLength={1000}
                                                />
                                                <span style={{ color: 'red' }}>{reasonValidation}</span>
                                            </div>
                                            <div hidden={isDependency ? false : true}>
                                                <p className="form-label hive-form-label mt-4">
                                                    Work Dependency <span className="required">*</span>{' '}
                                                    <span>
                                                        <img
                                                            src="/Images/work-info.svg"
                                                            className="ms-2"
                                                            alt="tooltip"
                                                            data-bs-toggle="tooltip"
                                                            data-bs-placement="bottom"
                                                            title="Please assign the responsible person for work dependency and update your responsibilities work on that leave-taking day"
                                                        />
                                                    </span>
                                                </p>
                                                <div className=" row justify-content-between mb-5">
                                                    <div className="col-md-8">
                                                        <label
                                                            className="form-label font-14 regular-text leave-date-label-color"
                                                            htmlFor="dependent-work"
                                                        >
                                                            Work Dependency
                                                        </label>
                                                        <input
                                                            onChange={(e) => {
                                                                OnValueChange(e);
                                                            }}
                                                            value={leaveform.dependent_work}
                                                            name="dependent_work"
                                                            type="text"
                                                            id="dependent-work"
                                                            className="form-control hive-form-control"
                                                            placeholder="Enter dependent work "
                                                            maxLength={255}
                                                        />
                                                        <span style={{ color: 'red' }}>{dependentWorkValidation}</span>
                                                    </div>
                                                    <div className="col-md-4 ">
                                                        <div>
                                                            <label
                                                                htmlFor="responsible-person"
                                                                className="form-label font-14 regular-text leave-date-label-color"
                                                            >
                                                                Responsible Person <span className="required">*</span>
                                                            </label>
                                                            <Select
                                                                className="dropdown"
                                                                name="assigned_to_id"
                                                                maxMenuHeight={150}
                                                                placeholder="Select"
                                                                value={selectedPeopleList}
                                                                options={showEmployee} // set list of the data
                                                                onChange={(e) => {
                                                                    handleChange(e);
                                                                }} // assign onChange function
                                                                isMulti
                                                                isClearable
                                                            />
                                                            <span style={{ color: 'red' }}>{responsiblePersonValidation}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="custom-upload-btn-wrapper  mt-5" hidden={isAttachment ? false : true}>
                                                <label className="form-label hive-form-label w-100 font-12 semibold-text">
                                                    Attachment{' '}
                                                </label>

                                                {leaveform?.attachment_url || selectedFileName ? null : (
                                                    <label htmlFor="certificate-Upload" className="goalform-custom-file-upload">
                                                        <img className="me-2" src="/Images/upload-icon.svg" alt="Upload Icon" />
                                                        Upload
                                                    </label>
                                                )}

                                                <input
                                                    id="certificate-Upload"
                                                    type="file"
                                                    className="profile-file-upload"
                                                    name="attachement_url"
                                                    ref={attachment}
                                                    onChange={(e) => {
                                                        addFileName(e);
                                                    }}
                                                />
                                                {selectedFileName != '' ? (
                                                    <span>
                                                        <label className="font-12 w-100 regular-text">
                                                            {selectedFileName}{' '}
                                                            <img
                                                                src="/Images/profile-certificate-cancel.svg"
                                                                className="cursor-pointer"
                                                                alt="Cancel Icon"
                                                                onClick={() => removeAttachment()}
                                                            />
                                                        </label>
                                                    </span>
                                                ) : leaveform?.attachment_url ? (
                                                    <span className="ms-4">
                                                        <img src="/Images/pin.svg" alt="Attachment Icon" className="me-2" />
                                                        <a href={leaveform?.attachment_url}>
                                                            {leaveform?.attachment_url?.split('amazonaws.com/')[1]}
                                                        </a>
                                                        <span>
                                                            {' '}
                                                            <img
                                                                src="/Images/profile-certificate-cancel.svg"
                                                                className="cursor-pointer"
                                                                alt="Cancel Icon"
                                                                onClick={() => removeAttachment()}
                                                            />
                                                        </span>
                                                    </span>
                                                ) : // <div className="row">
                                                    //         <img src="/Images/pin.svg" alt="Attachment Icon" className="me-2" />
                                                    //         <a
                                                    //         target="_blank"
                                                    //         className=" text-decoration-none"
                                                    //         //attachment-color text-decoration-none regular-text font-14 pe-2
                                                    //         id="attachment"
                                                    //         href={leaveform?.attachment_url}
                                                    //     > {leaveform?.attachment_url?.split('amazonaws.com/')[1]} </a>
                                                    //     <span>   <img src="/Images/profile-certificate-cancel.svg" className="cursor-pointer" alt="Cancel Icon" /></span>
                                                    // </div>
                                                    null}
                                            </div>
                                            <span className="text-danger" style={{ marginTop: '5px' }}>
                                                {attachmentValidation}
                                            </span>

                                            {applyLop ? (
                                                <div className="mb-5">
                                                    <input
                                                        onChange={(e) => {
                                                            setSelectedLop(!selectedLop);
                                                        }}
                                                        className="form-check-input leave-checkbox me-2"
                                                        type="checkbox"
                                                        defaultValue
                                                        id="LOP"
                                                    />
                                                    <label
                                                        className="form-check-label font-14 regular-text leave-date-label-color"
                                                        htmlFor="LOP"
                                                    >
                                                        {/* {updateEmpId == userDetails.roleId ? "This falls under LOP" : "Approve this as LOP2"} */}
                                                        This falls under LOP
                                                    </label>
                                                </div>
                                            ) : (
                                                <></>
                                            )}

                                            {userDetails.roleId == reportsTo ? (
                                                <div className="text-end my-5">
                                                    <a
                                                        onClick={() => {
                                                            // setleaveform(oldLeaveForm);
                                                            // setleaveEdit(false);

                                                            window.location.reload(false);
                                                        }}
                                                    >
                                                        <button className="btn cancel-button bold-text font-14 me-3">Cancel</button>
                                                    </a>
                                                    <button
                                                        disabled={disabledCheck}
                                                        className="btn medium-text font-14 primary-button"
                                                        onClick={() => {
                                                            wfhValidation('Updated and Approved');
                                                            //ApproveRequest('Approved');
                                                        }}
                                                    >
                                                        Update and Approve
                                                    </button>
                                                </div>
                                            ) : userDetails.roleId == leaveform?.emp_id || leaveId === undefined ? (
                                                <>
                                                    <div className="text-end my-5">
                                                        <a
                                                            onClick={() => {
                                                                ;
                                                                if (state?.switchTab == 'Dashboard') window.location.href = `overview`;
                                                                else if (!isProfile) {
                                                                    if (state?.switchTab == null) {
                                                                        navigate(`/leavewfh`);
                                                                    }
                                                                    else {
                                                                        navigate(`/leavewfh?tab=${state?.switchTab}`);
                                                                    }
                                                                }
                                                                else
                                                                    window.location.href = `/profilecontainer?EmpId=${userDetails.roleId}&IsTeamMember=true&tab=Leave`;
                                                            }}
                                                        >
                                                            <button className="btn cancel-button bold-text font-13 me-3">Cancel</button>
                                                        </a>
                                                        <button
                                                            disabled={
                                                                applyLop
                                                                    ? selectedLop
                                                                        ? false
                                                                        : true
                                                                    : submit != 'Apply'
                                                                        ? disabledCheck
                                                                        : false
                                                            }
                                                            className="btn medium-text font-12 primary-button"
                                                            onClick={() => {
                                                                wfhValidation();
                                                            }}
                                                        >
                                                            {submit}
                                                        </button>
                                                    </div>{' '}
                                                </>
                                            ) : null}
                                        </div>
                                    </>
                                ) : (
                                    <div className="custom-leave-panel">
                                        <span className="backarrow">
                                            <a
                                                onClick={() => {
                                                    if (state?.switchTab == null) {
                                                        navigate(`/leavewfh`);
                                                    } else {
                                                        navigate(`/leavewfh?tab=${state?.switchTab}`);
                                                    }
                                                    // navigate(`/leavewfh?tab=${state.switchTab}`);
                                                }}
                                            >
                                                <img src="/Images/back-arrow.svg" className="me-3 " alt="back-arrow" />
                                            </a>
                                        </span>
                                        <p className="font-15 mb-3 leave-header-color bold-text">Review Request</p>
                                        <div className="row mb-5 mt-4">
                                            <div className="col-md-8 align-items-center d-flex">
                                                <img
                                                    src="/Images/logo-person-user-person-icon.jpg"
                                                    className="leave-profile-img me-3"
                                                    alt="img"
                                                />
                                                <div>
                                                    <p className="font-16 regular-text leave-header-color mb-0">{leaveform.emp_name}</p>
                                                    <p className=" font-14 regular-text leave-date-label-color mb-0">{leaveform.domain}</p>
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                {leaveform?.type?.toLowerCase().includes('casual') ||
                                                    leaveform?.type?.toLowerCase().includes('sick') ? (
                                                    <div className="leave-rounded-7 border">
                                                        <span id="remainingLeave" className="badge leave-card-lable tt-bold font-12 mb-2">
                                                            {leaveform.type} Leave
                                                        </span>
                                                        <div className="d-flex justify-content-around mb-1">
                                                            <div>
                                                                <h3 className="tt-bold font-35 leave-available-color mb-0">
                                                                    {remaining?.availableLeave}
                                                                </h3>
                                                                <h5 className="regular-text leave-available-days-color font-12">
                                                                    Days Available
                                                                </h5>
                                                            </div>
                                                            <div>
                                                                <h3 className="tt-bold font-35 leave-used-color mb-0">
                                                                    {remaining?.tookCount == null ? 0 : remaining?.tookCount}
                                                                </h3>
                                                                <h5 className="regular-text leave-available-days-color font-12">
                                                                    Days Used
                                                                </h5>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ) : null}
                                            </div>
                                        </div>
                                        <div className="d-flex justify-content-between align-items-center mb-3">
                                            <p className="bold-text font-20 leave-type-color mb-0">{leaveform.type}</p>
                                            <span className={`${leaveform?.color} medium-text font-12 rounded-2`}>
                                                {' '}
                                                {leaveform?.status == 'Pending' ? (
                                                    <img src="/Images/clock.svg" alt="clockicon" className="me-1" />
                                                ) : null}
                                                {leaveform?.status}
                                            </span>
                                        </div>
                                        <div className="row justify-content-between align-items-end mb-4">
                                            <div className="col-md-8">
                                                <div className="row align-items-center justify-content-between">
                                                    <div className="col-md-5 pe-0">
                                                        <div className="border leave-border rounderd-3">
                                                            <h3 className="bold-text font-28 leave-type-color">
                                                                {moment(leaveform?.start_date).format('DD')}{' '}
                                                                <span className="font-14 regular-text leave-label-color">
                                                                    {moment(leaveform?.start_date).format('MMM`YY')}
                                                                </span>
                                                            </h3>
                                                            <h5 className="regular-text leave-type-color font-14">
                                                                {moment(leaveform?.start_date).format('dddd')}
                                                            </h5>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-1 p-0 text-center">
                                                        <img src="/Images/right-arrow.svg" alt="Icon" />
                                                    </div>
                                                    <div className="col-md-5 ps-0">
                                                        <div className="border leave-border rounderd-3">
                                                            <h3 className="bold-text font-28 leave-type-color ">
                                                                {moment(leaveform?.end_date).format('DD')}{' '}
                                                                <span className="font-14 regular-text leave-label-color">
                                                                    {moment(leaveform?.end_date).format('MMM`YY')}
                                                                </span>
                                                            </h3>
                                                            <h5 className="regular-text leave-type-color font-14">
                                                                {moment(leaveform?.end_date).format('dddd')}
                                                            </h5>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-md-3  justify-content-end align-items-end">
                                                <div className="text-end">
                                                    {(userDetails.roleId == reportsTo && leaveform?.status === 'Pending') ||
                                                        (userDetails.roleId == leaveform?.emp_id &&
                                                            leaveform?.status === 'Pending' &&
                                                            leaveform?.status != 'Approved' &&
                                                            leaveform?.status != 'Revoked') ? (
                                                        <>
                                                            {' '}
                                                            <h3 className="medium-text leave-days-requested-color font-15 mb-0">
                                                                {leaveform?.work_days_count}{' '}
                                                                {leaveform?.work_days_count > 1
                                                                    ? 'Work Days Requested'
                                                                    : 'Work Day Requested'}
                                                            </h3>
                                                            <button
                                                                onClick={() => {
                                                                    ;
                                                                    setCount({});
                                                                    setUpdateEmpId(leaveform.emp_id);
                                                                    setleaveEdit(true);
                                                                    setleaveUpdate(true);
                                                                    setIsEditMode(true);
                                                                    tempFunc(leaveTemplate);
                                                                }}
                                                                className="btn mt-2 leave-edit-request w-100 medium-text font-13"
                                                            >
                                                                <img
                                                                    src="/Images/edit-request-icon.svg"
                                                                    alt="Edit-icon"
                                                                    className="me-2 hive-table-sort"
                                                                />
                                                                Edit
                                                            </button>
                                                        </>
                                                    ) : (
                                                        <h3
                                                            style={{ height: '18px' }}
                                                            className="medium-text leave-days-requested-color font-15 mb-0"
                                                        >
                                                            {leaveform?.work_days_count}{' '}
                                                            {leaveform?.work_days_count > 1 ? 'Work Days Requested' : 'Work Day Requested'}
                                                        </h3>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                        {showHalfDayLeave ? (
                                            <div className="mb-5">
                                                <input
                                                    onChange={(e) => {
                                                        markasHalfDay(e);
                                                    }}
                                                    className="form-check-input leave-checkbox me-2"
                                                    type="checkbox"
                                                    defaultValue
                                                    // checked={leaveform.ishalf}
                                                    checked={isHalf}
                                                    id="HF"
                                                    disabled={!isApplyForm && !isEditMode}
                                                />
                                                <label
                                                    className="form-check-label font-14 regular-text leave-date-label-color"
                                                    htmlFor="HF"
                                                >
                                                    {/* {updateEmpId == userDetails.roleId ? "This falls under LOP" : "Approve this as LOP2"} */}
                                                    Half Day Leave
                                                </label>
                                            </div>
                                        ) : null}

                                        <div className="row">
                                            {userDetails.roleId == reportsTo && leaveform?.status == 'Pending' ? (
                                                <>
                                                    <label className="form-label leave-label-color font-14 bold-text" htmlFor="wfh-reason">
                                                        Reason for Leave <span className="required">*</span>
                                                    </label>
                                                    <textarea
                                                        disabled
                                                        className="form-control custom-comment-box leave-comment-box medium-text font-12"
                                                        id="comments"
                                                        placeholder="Enter the reason "
                                                        name="reason"
                                                        value={leaveform.reason}
                                                        onChange={(e) => OnValueChange(e)}
                                                        maxLength={1000}
                                                    />
                                                </>
                                            ) : leaveform?.status == 'Rejected' ? (
                                                <>
                                                    <label className="form-label leave-label-color  font-14 bold-text" htmlFor="wfh-reason">
                                                        Reason for leave <span className="required">*</span>
                                                    </label>
                                                    <textarea
                                                        disabled
                                                        className="form-control custom-comment-box leave-comment-box medium-text font-12"
                                                        id="wfh-reason"
                                                        placeholder="Enter the reason "
                                                        name="reason"
                                                        value={leaveform.reason}
                                                        onChange={(e) => OnValueChange(e)}
                                                        maxLength={1000}
                                                    />
                                                </>
                                            ) : leaveform?.status ? (
                                                <>
                                                    <label className="form-label leave-label-color font-14 bold-text" htmlFor="wfh-reason">
                                                        Reason for leave <span className="required">*</span>
                                                    </label>
                                                    <textarea
                                                        disabled
                                                        className="form-control custom-comment-box leave-comment-box medium-text font-12"
                                                        id="wfh-reason"
                                                        placeholder="Enter the reason "
                                                        name="reason"
                                                        value={leaveform.reason}
                                                        onChange={(e) => OnValueChange(e)}
                                                        maxLength={1000}
                                                    />
                                                </>
                                            ) : null}
                                        </div>
                                        {/* <div className="mb-4">
                                                <textarea id="disabledTextInput" className="form-control custom-comment-box leave-comment-box medium-text font-13" disabled placeholder="My child is out of school for break and I need to stay home for childcare." defaultValue={""} />
                                            </div> */}
                                        <div className="row mt-4 mb-4">
                                            <div className="col-md-6">
                                                <div>{bindAttachmentName()}</div>
                                            </div>
                                            <div className="col-md-6" hidden={Availability?.length ? false : true}>
                                                <label className="form-label font-14 bold-text leave-label-color">
                                                    Availability <span className="required">*</span>
                                                </label>
                                                <p className="availability-color regular-text font-14" id="availability">
                                                    {leaveform.availabilityName}
                                                </p>
                                            </div>
                                        </div>
                                        <div hidden={responsiblePerson?.length ? false : true}>
                                            <p className="tt-bold font-16 leave-label-color">Dependent Work Information</p>
                                            <div className=" row justify-content-between">
                                                <div className="col-md-8">
                                                    <label className="form-label font-14 bold-text leave-label-color">
                                                        Work Dependency{' '}
                                                    </label>
                                                    <p className="leave-formtext-color regular-text font-14 text-break">
                                                        {leaveform.dependent_work}
                                                    </p>
                                                </div>
                                                <div className="col-md-4 d-flex justify-content-end">
                                                    <div>
                                                        <label className="form-label font-14 bold-text leave-label-color">
                                                            Responsible Person
                                                        </label>
                                                        <p className="leave-formtext-color regular-text font-14">
                                                            {leaveform.responsibleName}
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        {userDetails.roleId == reportsTo && leaveform?.status == 'Pending' ? (
                                            <>
                                                <label className="form-label leave-label-color font-14 bold-text" htmlFor="wfh-reason">
                                                    Comments <span className="required"></span>
                                                </label>
                                                <textarea
                                                    ref={textarearef}
                                                    onBlur={() => {
                                                        textarearef.current.scrollTop = 0;
                                                    }}
                                                    className="form-control hive-form-control hive-leave-textarea"
                                                    id="wfh-reason-rejection"
                                                    placeholder="Enter the comments "
                                                    name="comments"
                                                    value={leaveform.comments}
                                                    onChange={(e) => OnValueChange(e)}
                                                    maxLength={2500}
                                                />
                                                <label className="text-danger">{commentsValidation}</label>
                                            </>
                                        ) : (leaveform?.status == 'Rejected' || leaveform?.status == 'Approved') && leaveform.comments ? (
                                            <>
                                                <label className="form-label leave-label-color font-14 bold-text" htmlFor="wfh-reason">
                                                    Comments for {leaveform?.status} <span className="required"></span>
                                                </label>
                                                <textarea
                                                    ref={textarearef}
                                                    onBlur={() => {
                                                        textarearef.current.scrollTop = 0;
                                                    }}
                                                    className="form-control hive-form-control hive-leave-textarea"
                                                    id="wfh-reason-rejection"
                                                    placeholder="Enter the comments "
                                                    name="comments"
                                                    value={leaveform.comments}
                                                    onChange={(e) => OnValueChange(e)}
                                                    disabled
                                                    maxLength={2500}
                                                />
                                            </>
                                        ) : null}

                                        {Number(remaining?.availableLeave) - Number(leaveform?.work_days_count) < 0 &&
                                            userDetails.role != 'Team Member' &&
                                            leaveform.status == 'Pending' &&
                                            userDetails.roleId == reportsTo ? (
                                            <div className="mb-5">
                                                <input
                                                    onChange={(e) => {
                                                        setLop(e.target.checked);
                                                    }}
                                                    className="form-check-input leave-checkbox me-2"
                                                    type="checkbox"
                                                    defaultValue
                                                    id="LOP"
                                                />
                                                <label
                                                    className="form-check-label font-14 regular-text leave-date-label-color"
                                                    htmlFor="LOP"
                                                >
                                                    {/* {updateEmpId == userDetails.roleId ? "This falls under LOP" : "Approve this as LOP1"} */}
                                                    Approve this as LOP
                                                </label>
                                            </div>
                                        ) : (
                                            <></>
                                        )}

                                        <div className="d-flex justify-content-between align-items-center mb-4 mt-4">
                                            <a
                                                onClick={() => {
                                                    if (!isProfile) {
                                                        if (state?.switchTab == null) {
                                                            navigate(`/leavewfh`);
                                                        } else {
                                                            navigate(`/leavewfh?tab=${state?.switchTab}`);
                                                        }
                                                    }
                                                    else
                                                        window.location.href = `/profilecontainer?EmpId=${userDetails.roleId}&IsTeamMember=true&tab=Leave`;
                                                }}
                                            >
                                                <button className="btn hive-btn-secondary p-0">Cancel</button>
                                            </a>
                                            <div>
                                                {userDetails.roleId == reportsTo && leaveform?.status === 'Pending' ? (
                                                    <>
                                                        <button
                                                            onClick={() => {
                                                                RejectRequest('Rejected');
                                                            }}
                                                            className="btn secondary-button leave-reject-button medium-text font-13 me-2"
                                                        >
                                                            Reject Request
                                                        </button>
                                                        <button
                                                            onClick={() => {
                                                                //;
                                                                wfhValidation('Approved');
                                                            }}
                                                            className="btn primary-button leave-approve-button meApproveRequestdium-text font-13"
                                                        >
                                                            Approve Request
                                                        </button>
                                                    </>
                                                ) : leaveform?.status === 'Approved' &&
                                                    userDetails.role !== 'Hr' &&
                                                    userDetails.role !== 'Team Member' &&
                                                    userDetails.roleId == reportsTo ? (
                                                    <button
                                                        onClick={() => {
                                                            ApproveRequest('Revoked');
                                                        }}
                                                        className="btn hive-btn-primary"
                                                    >
                                                        Revoke
                                                    </button>
                                                ) : null}
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                            <div className="col-md-3">
                                {leaveEdit ? (
                                    <>
                                        <div className="bg-white mb-3 px-3 py-3 leave-rounded-7">
                                            <p className="bold-text leave-header-color font-15">Available Leaves</p>
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <h3 className="tt-bold font-35 leave-used-color">{Count?.casual}</h3>
                                                    <h5 className="medium-text leave-available-days-color font-13">Casual</h5>
                                                </div>
                                                <div className="col-md-6">
                                                    <h3 className="tt-bold font-35 leave-available-color">{Count?.sick}</h3>
                                                    <h5 className="medium-text leave-available-days-color font-13">Sick</h5>
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                ) : (
                                    <>
                                        {logs?.length > 0 ? (
                                            <div className="bg-white mb-3 px-3 rounded-3 py-3">
                                                <p className="bold-text leave-header-color font-15">Version History</p>
                                                <ul className="custom-bullets list-unstyled mb-0">
                                                    {logs.map((log) => {
                                                        return (
                                                            <li className="font-13 regular-text pb-3 leave-days-requested-color version-history ">
                                                                {log.id == 1 ? (
                                                                    <>
                                                                        <p className="mb-0">{log.actions}</p>
                                                                        <span>{moment(log.created_at).utc().format('MMMM DD, YYYY')}</span>
                                                                    </>
                                                                ) : (
                                                                    <>
                                                                        <p className="mb-0">
                                                                            {log.emp_name} {log.actions}
                                                                        </p>
                                                                        <span>{moment(log.created_at).utc().format('MMMM DD, YYYY')}</span>
                                                                    </>
                                                                )}
                                                            </li>
                                                        );
                                                    })}
                                                </ul>
                                            </div>
                                        ) : null}
                                    </>
                                )}

                                <div className="leave-policy-background leave-rounded-7 px-3 py-4">
                                    <a
                                     style={{cursor:"pointer"}} onClick={async () => {

                                        window.open(await getS3("https://ava-hive-prod-image-s3.s3.ap-south-1.amazonaws.com/AVA Leave policy.pdf"), "_blank");

                                    }} 
                                        target="_blank"
                                        className="leave-policy-color bold-text font-15 ps-3"
                                    >
                                        Review our Employee Leave Policies
                                        <span>
                                            <img src="/Images/leave-policy-arrow.svg" className="me-2" alt="policy-arrow" />
                                        </span>
                                    </a>
                                    <img src="/Images/leave-policy.svg" alt="Goto" width="100%" className="mt-4" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
function mapStateToProps(state) {
    return {
        websocket: state.webSocketAPI,
    };
}

export default connect(mapStateToProps)(LeaveForm);
